import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUserLargeComponent } from "./med-icon-user-large.component";

@NgModule({
  declarations: [
    MedIconUserLargeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUserLargeComponent,
  ],
})
export class MedIconUserLargeModule { }
